<template>
  <q-page
    :style-fn="tweakHeight"
    :style="`height: ${offset}`"
  >
    <div v-if="!$config.panoramas.public && !username" class="q-py-xl flex flex-center panel-title">
      {{ $t('tools.panorama.mustLogin') }}
    </div>
    <panorama-viewer
      v-else
      :horizontal="horizontal"
      :offset="offset"
    />
  </q-page>
</template>

<script>
import PanoramaViewer from 'components/Panorama/PanoramaViewer.vue'
import { Loading, QPage } from 'quasar'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'PanoramasInfo',
  components: {
    PanoramaViewer,
    QPage
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('basicLayout/panoramaHeader', true)
      vm.params = to.params
      vm.query = to.query
      if (vm.query) {
        if (vm.query.access_token) {
          axios.get(vm.$config.oauth.profile, { params: { access_token: vm.query.access_token } })
            .then(response => {
              vm.$store.commit('auth/setUsername', response.data.username)
              vm.$store.commit('auth/setAccessToken', vm.query.access_token)
              vm.$store.commit('basicLayout/showAuthBtn', false)
            })
        }
        if (vm.query.username && vm.query.pwd) {
          vm.$store.dispatch('auth/credentialsLogin', { username: vm.query.username, password: vm.query.pwd })
          vm.$store.commit('basicLayout/showAuthBtn', false)
        }
        if (vm.query.h && vm.query.h === 'true') {
          vm.horizontal = true
        }
        if (to.query.screenshot) {
          vm.$store.commit('panorama/setScreenshot', to.query.screenshot)
        }
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (to.query && to.query.h && to.query.h === 'true') {
      this.horizontal = true
    } else if (to.query && to.query.h && to.query.h === 'false') {
      this.horizontal = false
    }
    this.params = to.params
    if (to.params.p !== from.params.p) {
      this.getResult()
    } else {
      if (this.params.head === 'to_point') {
        const p = to.params.p.split(',')
        const latLng = {
          lat: parseFloat(p[0]),
          lng: parseFloat(p[1])
        }
        const head = 90 - Math.atan2((latLng.lng - this.latLng.lng), (latLng.lat - this.latLng.lat)) * 180 / Math.PI
        this.$store.commit('panorama/setHead', { head, from: 'route' })
      } else {
        this.$store.commit('panorama/setHead', { head: parseFloat(to.params.head), from: 'route' })
      }
    }
    if (to.query.screenshot) {
      this.$store.commit('panorama/setScreenshot', to.query.screenshot)
    }
    if (to.query.f) {
      const query = to.query.f.toLowerCase()
      if (query.includes('lateral')) {
        const isActive = this.$store.state.panorama.showLateral
        if (!isActive) {
          this.$store.dispatch('panorama/selectLateral')
        } else {
          this.$store.commit('panorama/setSelectedLateral', null)
        }
        this.$store.commit('panorama/setShowLateral', !isActive)
      } else if (query === 'previous') {
        this.$store.dispatch('panorama/getPreviousPano')
      } else if (query === 'next') {
        this.$store.dispatch('panorama/getNextPano')
      } else if (query.includes('rotate')) {
        let angle
        if (query.includes('right')) {
          angle = 90
        } else if (query.includes('left')) {
          angle = -90
        } else if (query.includes('180')) {
          angle = 180
        }
        if (angle) {
          const head = this.head + angle
          this.$store.commit('panorama/setHead', { head, from: 'tools' })
          const isActive = this.$store.state.panorama.showLateral
          if (isActive) {
            this.$store.dispatch('panorama/selectLateral')
          }
        }
      }
      this.updateLatLngRoute()
    }
    next()
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$config.panoramas.public) {
        this.getResult()
      } else if (!this.query || !(this.query.access_token || this.query.username)) {
        this.username ? this.getResult() : this.$store.commit('basicLayout/showAuthDialog', true)
      }
    })
  },
  beforeDestroy () {
    this.$store.commit('basicLayout/panoramaHeader', false)
  },
  data () {
    return {
      params: '',
      query: null,
      prompt: false,
      offset: null,
      horizontal: false
    }
  },
  computed: {
    ...mapState({
      username: state => state.auth.username,
      loading: state => state.panorama.loading,
      head: state => state.panorama.head,
      headFrom: state => state.panorama.headFrom,
      latLng: state => state.panorama.latLng,
      name: state => state.panorama.name,
      altitude: state => state.panorama.altitude,
      selectedCampaign: state => state.panorama.selectedCampaign
    })
  },
  methods: {
    getResult () {
      if (!this.params.p) {
        return
      }
      const p = this.params.p.split(',')
      const latLng = {
        lat: parseFloat(p[0]),
        lng: parseFloat(p[1])
      }
      if (this.query && this.query.c) {
        const category = { code: this.query.c }
        this.$store.commit('panorama/setSelectedCategory', category)
      }
      this.$store.dispatch('panorama/getPanoByPoint', latLng).then(() => {
        if (!this.params.head) {
          return
        }
        if (!isNaN(this.params.head)) {
          this.$store.commit('panorama/setHead', { head: parseFloat(this.params.head), from: 'route' })
        }
      })
    },
    updateHeadRoute () {
      if (this.headFrom !== 'route') {
        const campaign = `${this.params.campaign}`
        const p = `${this.params.p}`
        const head = `${this.head}`
        const query = { c: this.query && this.query.c }
        const altitude = `${this.altitude}`
        const route = query.c ? { name: 'mapiastreets', params: { campaign, p, head, altitude }, query } : { name: 'mapiastreets', params: { campaign, p, head, altitude } }
        this.$router.replace(route).catch(() => {})
      }
    },
    updateLatLngRoute () {
      if (this.params.head === 'to_point') {
        const p = this.params.p.split(',')
        const latLng = {
          lat: parseFloat(p[0]),
          lng: parseFloat(p[1])
        }
        const head = 90 - Math.atan2((latLng.lng - this.latLng.lng), (latLng.lat - this.latLng.lat)) * 180 / Math.PI
        this.$store.commit('panorama/setHead', { head, from: 'to_point' })
      }
      if (this.latLng && this.latLng.lat && this.latLng.lng) {
        const campaign = `${this.params.campaign}`
        const p = `${this.latLng.lat},${this.latLng.lng}`
        const head = `${this.head}`
        const query = { c: this.query && this.query.c }
        const altitude = `${this.altitude}`
        const route = query.c ? { name: 'mapiastreets', params: { campaign, p, head, altitude }, query } : { name: 'mapiastreets', params: { campaign, p, head, altitude } }
        this.$router.replace(route).catch(() => {})
      }
    },
    tweakHeight (offset) {
      this.offset = offset ? `calc(100vh - ${offset}px)` : '100vh'
      return this.offset
    }
  },
  watch: {
    latLng: ['updateLatLngRoute'],
    head: ['updateHeadRoute'],
    selectedCampaign: ['getResult'],
    loading: function (loading) {
      if (loading) {
        Loading.show()
      } else {
        Loading.hide()
      }
    },
    username: function (username) {
      if (username) {
        this.getResult()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: $grey-1;
}
</style>
